var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnicaldescription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.93 28.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1f2f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Technical description") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-249.69,711.79l-2.17-.47a11.78,11.78,0,0,0-.7-1.68l1.2-1.86a0.84,0.84,0,0,0-.11-1l-3.37-3.37a0.84,0.84,0,0,0-1-.11l-1.86,1.2a11.77,11.77,0,0,0-1.68-.7l-0.47-2.17a0.85,0.85,0,0,0-.82-0.67h-4.76a0.85,0.85,0,0,0-.82.67l-0.47,2.17a11.78,11.78,0,0,0-1.68.7l-1.86-1.2a0.84,0.84,0,0,0-1,.11l-3.37,3.37a0.84,0.84,0,0,0-.11,1l1.2,1.86a11.77,11.77,0,0,0-.7,1.68l-2.15.47a0.83,0.83,0,0,0-.65.82v4.76a0.83,0.83,0,0,0,.65.82l2.16,0.47a11.76,11.76,0,0,0,.69,1.68l-1.2,1.86a0.84,0.84,0,0,0,.11,1l3.37,3.37a0.84,0.84,0,0,0,1,.11l1.86-1.2a11.77,11.77,0,0,0,1.68.7l0.47,2.15a0.83,0.83,0,0,0,.82.65h4.76a0.83,0.83,0,0,0,.82-0.65l0.47-2.16a11.76,11.76,0,0,0,1.68-.69l1.86,1.2a0.84,0.84,0,0,0,1-.11l3.37-3.37a0.84,0.84,0,0,0,.11-1l-1.2-1.86a11.77,11.77,0,0,0,.7-1.68l2.17-.47a0.85,0.85,0,0,0,.67-0.82v-4.76A0.85,0.85,0,0,0-249.69,711.79Zm-13.4,9.92a6.73,6.73,0,0,1-6.72-6.72,6.73,6.73,0,0,1,6.72-6.72,6.73,6.73,0,0,1,6.72,6.72A6.73,6.73,0,0,1-263.09,721.71Z",
    transform: "translate(277.13 -700.92)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: -244.21,
    y: 721.05,
    width: 2.14,
    height: 13.89,
    rx: 0.69,
    ry: 0.69,
    transform: "matrix(0, -1, 1, 0, -694.01, -216.07)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: -244.21,
    y: 695.08,
    width: 2.14,
    height: 13.89,
    rx: 0.69,
    ry: 0.69,
    transform: "translate(-668.04 -242.04) rotate(-90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: -241.07,
    y: 719.02,
    width: 2.14,
    height: 7.59,
    rx: 0.69,
    ry: 0.69,
    transform: "translate(-685.68 -218.11) rotate(-90)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: -241.07,
    y: 713.77,
    width: 2.14,
    height: 7.59,
    rx: 0.69,
    ry: 0.69,
    transform: "translate(-680.43 -223.35) rotate(-90)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: -241.07,
    y: 708.5,
    width: 2.14,
    height: 7.59,
    rx: 0.69,
    ry: 0.69,
    transform: "translate(-675.16 -228.62) rotate(-90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: -241.07,
    y: 702.95,
    width: 2.14,
    height: 7.59,
    rx: 0.69,
    ry: 0.69,
    transform: "translate(-669.61 -234.17) rotate(-90)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicaldescription);
export default __webpack_public_path__ + "static/media/Technical description.87e9439f.svg";
export { ForwardRef as ReactComponent };